import type { FC } from 'react'
import { useTranslation } from '@/translations/i18n'

interface ScoreFormListingDetailsProps {
	facilities: {
		keyName: 'bedrooms' | 'beds' | 'baths' | 'guests'
		count: number
	}[]
}

// const lineClassname =
// 	'grid grid-cols-[0.5fr_2fr] gap-4 border-neutral-200 border-b py-4 items-center'
export const ScoreFormListingDetails: FC<ScoreFormListingDetailsProps> = ({
	facilities
}) => {
	const { t } = useTranslation()

	if (facilities.length === 0) {
		return null
	}
	return (
		<div className='mb-6 flex flex-col gap-4'>
			<div className='flex flex-col gap-1'>
				<h3 className='font-bold text-lg text-neutral-900'>
					{t('luxe_submissions:listing_details')}
				</h3>
				<div className='flex gap-1'>
					{facilities.map((item, index, arr) => (
						<p
							className='text-md/6 text-neutral-900'
							key={item.keyName}
						>
							{t(
								`luxe_submissions:facilities_types.${item.keyName}`,
								{
									count: item.count ?? undefined
								}
							)}

							{index < arr.length - 1 && ' |'}
						</p>
					))}
				</div>
			</div>

			{/* TODO add when BE will be ready */}
			{/* <div>
				{listingData.amenities && listingData.amenities.length > 0 && (
					<div className={lineClassname}>
						<span className='text-neutral-600 text-xs'>
							{t('luxe_submissions:amenities')}
						</span>
						<div className='flex flex-wrap gap-2'>
							{listingData.amenities.map((amenity) => (
								<span
									className='shrink-0 rounded-lg border border-neutral-300 px-2 py-1 font-medium text-neutral-700 text-xs'
									key={amenity.id}
								>
									{t(
										`luxe_submissions:amenities_types.${amenity.keyName}`
									)}
								</span>
							))}
						</div>
					</div>
				)}
				{listingData.essentialAmenities &&
					listingData.essentialAmenities.length > 0 && (
						<div className={lineClassname}>
							<span className='text-neutral-600 text-xs'>
								{t('luxe_submissions:essential_amenities')}
							</span>
							<div className='flex flex-wrap gap-2'>
								{listingData.essentialAmenities.map(
									(amenity) => (
										<span
											className='shrink-0 rounded-lg border border-neutral-300 px-2 py-1 font-medium text-neutral-700 text-xs'
											key={amenity.id}
										>
											{t(
												`luxe_submissions:essential_amenities_types.${amenity.keyName}`
											)}
										</span>
									)
								)}
							</div>
						</div>
					)}
			</div> */}
		</div>
	)
}
